import { isNil } from 'ramda'
import { useState } from 'react'

import ThumbWithMenu from '../ThumbWithMenu/ThumbWithMenu'
import useStyles from './ObservationItem.styles'
import {
  MenuContextualItems,
  Observation,
  OnActionCallback,
  TagDecorator,
} from './types'

export interface ObservationItemProps {
  observation: Observation
  isActive?: boolean
  isDisabled?: boolean
  isClickDisabled?: boolean
  tagDecorator?: TagDecorator
  onClick?: OnActionCallback
  menuContextualItems?: MenuContextualItems
}

const ObservationItem = ({
  observation,
  onClick,
  tagDecorator,
  menuContextualItems,
  isActive: isActiveProp,
  isDisabled: isDisabledProp,
  isClickDisabled: isClickDisabledProp,
}: ObservationItemProps) => {
  const classes = useStyles()

  // Internal state for values that can be changed by children via setters
  const [isDisabledState, setDisabled] = useState(false)
  const [isActiveState, setActive] = useState(false)

  // Use props directly when provided, fallback to internal state
  const isDisabled = !isNil(isDisabledProp) ? isDisabledProp : isDisabledState
  const isActive = !isNil(isActiveProp) ? isActiveProp : isActiveState
  const isClickDisabled = isClickDisabledProp ?? false

  /** Executes given `callback` when click is not disabled */
  const withMiddleware = (callback: () => void) => () => {
    if (!isDisabled && !isClickDisabled) {
      callback()
    }
  }

  return (
    <div className={classes.container}>
      <ThumbWithMenu
        onClick={withMiddleware(
          () => onClick && onClick({ observation, setDisabled, setActive })
        )}
        isActive={isActive}
        isDisabled={isDisabled}
        isClickDisabled={isClickDisabled}
        alt={observation.filename}
        fileName={observation.filename}
        src={observation.thumbnail}
        tagDecorator={
          tagDecorator && tagDecorator({ observation, hideIcon: true })
        }
        tagIconDecorator={
          tagDecorator && tagDecorator({ observation, iconOnly: true })
        }
        contextualItems={
          menuContextualItems &&
          menuContextualItems({
            observation,
            setDisabled,
            setActive,
          })
        }
        observation={observation}
      />
    </div>
  )
}

export default ObservationItem
